import config from '../config';

export default () => {
  window.location.assign(
    `${config.loginUrl}&returnUrl=${window.location.href}`,
  );
};
